import { useState } from 'react';
import { Button, COLOR_NEUTRAL_70, Conditional, IconX, Text } from '@consumidor-positivo/aurora';
import { useRedline } from '@libs/redline';
import { getAnonymousID } from 'redline-client-sdk';
import { addCookie } from '@libs/utils/helpers/getSafeCookies';
import './styles.scss';

interface NotificationFakeDoorProps {
  setShowNotificationFakeDoor: (show: boolean) => void;
  setShowNotificationIcon: (show: boolean) => void;
}

const NotificationFakeDoor = ({ setShowNotificationFakeDoor, setShowNotificationIcon }: NotificationFakeDoorProps) => {
  const { track: trackRedline } = useRedline();
  const [currentData, setCurrentData] = useState<string>('initial');
  interface dataProps {
    initial: { title: string; content: string };
    interested: { title: string; content: string };
    notInterested: { title: string; content: string };
  }

  const data: dataProps = {
    initial: {
      title: '🚀 Notificações em tempo real chegando!',
      content: 'Quer ser avisado por aqui sempre que encontrarmos novas dívidas no seu nome, descontos melhores ou oportunidades para pagar menos?',
    },
    interested: {
      title: '✨ Agradecemos o seu feedback!',
      content:
        'Ainda estamos desenvolvendo essa funcionalidade, mas ficamos felizes em saber que você tem interesse. Fique de olho, teremos novidades em breve!',
    },
    notInterested: {
      title: '✨ Obrigado pela sua resposta!',
      content: 'Você pode conferir suas dívidas e descontos sempre que quiser. Se mudar de ideia, estaremos por aqui para te manter informado. 😉',
    },
  };

  const anonymousId = getAnonymousID();
  const cookie = 'fd_notification_id';

  const handleInterest = () => {
    setCurrentData('interested');
    trackRedline.userTracking.elementClicked({
      elementType: 'button',
      name: 'notification-fake-door',
      text: 'Sim, quero ser notificado!',
      location: 'menu-notificacoes',
    });

    addCookie({ key: cookie, value: anonymousId });
    setShowNotificationIcon(false);
  };

  const handleNotInterest = () => {
    setCurrentData('notInterested');
    trackRedline.userTracking.elementClicked({
      elementType: 'button',
      name: 'notification-fake-door',
      text: 'Não tenho interesse',
      location: 'menu-notificacoes',
    });

    addCookie({ key: cookie, value: anonymousId });
    setShowNotificationIcon(false);
  };

  const handleClose = () => {
    setShowNotificationFakeDoor(false);
  };

  return (
    <div className="notification-fake-door">
      <div className="notification-fake-door__close">
        <IconX rawColor={COLOR_NEUTRAL_70} onClick={handleClose} />
      </div>
      <Text variant="heading-small" weight="bold">
        {data[currentData as keyof dataProps].title}
      </Text>
      <Text color="secondary">{data[currentData as keyof dataProps].content}</Text>

      <Conditional
        condition={currentData === 'initial'}
        renderIf={
          <div className="notification-fake-door__buttons">
            <Button type="outlined" onClick={handleInterest}>
              Sim, quero ser notificado!
            </Button>
            <Button type="ghost" onClick={handleNotInterest}>
              Não tenho interesse
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default NotificationFakeDoor;
